var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 13V11.9981C10.5 10.8946 11.3983 10 12.4979 10H14.5021C15.6055 10 16.5 10.8944 16.5 11.9981V13H19.0014C19.5529 13 20 13.4439 20 14C20 14.5523 19.5542 15 19.0014 15H16.5V16.0019C16.5 17.1054 15.6017 18 14.5021 18H12.4979C11.3945 18 10.5 17.1056 10.5 16.0019V15H0.998646C0.447109 15 0 14.5561 0 14C0 13.4477 0.44577 13 0.998646 13H10.5ZM3.5 1.9981C3.5 0.89458 4.39826 0 5.49791 0H7.50209C8.6055 0 9.5 0.894415 9.5 1.9981V3H19.0014C19.5529 3 20 3.44386 20 4C20 4.55228 19.5542 5 19.0014 5H9.5V6.0019C9.5 7.10542 8.60174 8 7.50209 8H5.49791C4.3945 8 3.5 7.10559 3.5 6.0019V5H0.998646C0.447109 5 0 4.55614 0 4C0 3.44772 0.44577 3 0.998646 3H3.5V1.9981ZM5.5 2V6H7.5V2H5.5ZM12.5 12V16H14.5V12H12.5Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterMobile);
export default __webpack_public_path__ + "static/media/filter-mobile.3e96a87fe12cb2cd63f646415634028a.svg";
export { ForwardRef as ReactComponent };